// utils
import axios from "src/utils/axios";
import apiSlice from "src/utils/api-slice";

// ----------------------------------------------------------------------

const API_ENDPOINTS = {
    carriers: "/carrier_account/query_all",
    checkProviderAgreement: "/carrier/is_agree_fixed_agreement",
};

const checkProviderAgreement = (code) => axios.get(`${API_ENDPOINTS.checkProviderAgreement}`, {
    params: {
        provider_id: code
    }
});
// ----------------------------------------------------------------------
const {
    useGetCarrierListQuery,

} = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getCarrierList: builder.query({
            keepUnusedDataFor: 5,
            providesTags: ["CarrierList"],
            query: () => `${API_ENDPOINTS.carriers}`,
            transformResponse: ({ data }, meta, arg) => data
        }),
    }),
    overrideExisting: true
});

const getCarrierListAPI = (request) => axios.get(`${API_ENDPOINTS.carriers}`, {});
// ----------------------------------------------------------------------

export {
    checkProviderAgreement as checkProviderAgreementAPI,
    useGetCarrierListQuery,
    getCarrierListAPI,
};
